/* eslint-disable */
import React, { useRef, useState } from 'react';
import ReactModal from 'react-modal';
import closeSvg from 'src/assets/close.svg';
import { CommonDropdown, CustomCheckBox, RegularButton, CommonInput } from 'pg-ui-library';
import { useTranslation } from 'react-i18next';
import { useActions } from 'src/hooks/useActions';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { IBank } from 'src/interfaces';
import { CloseIcon, DependentsForm, DependentsForms, HeadingShow, ActionWrapper, FormInputWrapper } from './styles';
import { bankTypeOptions } from 'src/modules/personal-info';
import { useAddBank } from 'src/modules/personal-info/mutations/add-update-bank.mutation';
import CircularProgress from '@mui/material/CircularProgress';

interface BanksFormModalProps {
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
  isUpdate: boolean;
  personnelNumber: string;
}

export const BanksFormModal: React.FC<BanksFormModalProps> = ({ isOpen, setIsOpen, isUpdate, personnelNumber }) => {
  const modalRef = useRef(null);
  const { t } = useTranslation();
  const { getPersonalInfo } = useActions();
  const { mutate, isLoading } = useAddBank();
  const [formError, setFormError] = useState<string | null>(null);

  const validationSchema = yup.object({
    name: yup.string().required('Name is required'),
    accountNumber: yup
      .string()
      .required('Account Number is required')
      .matches(/^\d+$/, 'Account Number must be numeric'),
    accountId: yup.string().required('Account Id is required'),
    type: yup.string().required('Type is required'),
  });

  const formik = useFormik({
    initialValues: {
      name: '',
      accountNumber: '',
      accountId: '',
      type: 'savings' as 'SavingsAccount' | 'CheckingAccount',
    },
    validationSchema,
    onSubmit: async (values: IBank) => {
      try {
        console.log('ajhsajhsahjsajhsahj');
        console.log('values', values);

        setFormError(null);
        mutate(
          { bank: values, personnelNumber },
          {
            onSuccess: () => {
              // getPersonalInfo();
              // setIsOpen(false);
              formik.resetForm();
            },
            onError: (err: any) => {
              setFormError(err?.response?.data?.message || 'An error occurred while saving.');
            },
          }
        );
      } catch (error) {
        console.error('Error during form submition', error);
      }
    },
  });

  const handleModalClose = () => {
    console.log('hbjsajhasjhasjhashj');
    setIsOpen(false);
    formik.resetForm();
    setFormError(null);
  };

  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={handleModalClose}
      ariaHideApp={false}
      style={{
        overlay: { backgroundColor: 'rgba(0, 0, 0, 0.6)' },
        content: {
          borderRadius: '10px',
          background: '#f3f4f8',
          margin: 'auto',
          maxWidth: '1200px',
          minWidth: '1200px',
          height: '340px',
          display: 'flex',
          flexDirection: 'column',
        },
      }}
      contentRef={(node: any) => (modalRef.current = node)}
    >
      <CloseIcon src={closeSvg} onClick={handleModalClose} />
      <HeadingShow>Bank Module</HeadingShow>

      <DependentsForms>
        {/* Fixed: Ensure this is a form element */}
        <DependentsForm
          onSubmit={formik.handleSubmit}
          style={{ padding: '20px' }}
          as="form" // Add this line to enforce form element
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              flexWrap: 'nowrap',
              gap: '90px', // customizable
            }}
          >
            <FormInputWrapper style={{ flex: '1', minWidth: '200px' }}>
              <CommonInput
                id="name"
                name="name"
                label="Bank Name"
                value={formik.values.name}
                onChange={formik.handleChange}
                required
              />
              {formik.touched.name && formik.errors.name && <div style={{ color: 'red' }}>{formik.errors.name}</div>}
            </FormInputWrapper>

            <FormInputWrapper style={{ flex: '1', minWidth: '200px' }}>
              <CommonInput
                id="accountId"
                name="accountId"
                label="Account ID*"
                value={formik.values.accountId}
                onChange={formik.handleChange}
                required
              />
              {formik.touched.accountId && formik.errors.accountId && (
                <div style={{ color: 'red' }}>{formik.errors.accountId}</div>
              )}
            </FormInputWrapper>

            <FormInputWrapper style={{ flex: '1', minWidth: '200px' }}>
              <CommonInput
                id="accountNumber"
                name="accountNumber"
                label="Account Number*"
                value={formik.values.accountNumber}
                onChange={formik.handleChange}
                required
              />
              {formik.touched.accountNumber && formik.errors.accountNumber && (
                <div style={{ color: 'red' }}>{formik.errors.accountNumber}</div>
              )}
            </FormInputWrapper>

            <FormInputWrapper style={{ flex: '1', minWidth: '200px' }}>
              <CommonDropdown
                label="Account Type*"
                id="type"
                name="type"
                options={bankTypeOptions}
                value={formik.values.type}
                setValue={(value: string) => formik.setFieldValue('type', value)}
                style={{ marginBottom: '16px', minWidth: '200px' }}
                required
              />
              {formik.touched.type && formik.errors.type && <div style={{ color: 'red' }}>{formik.errors.type}</div>}
            </FormInputWrapper>
          </div>

          {formError && <div style={{ color: 'red', marginLeft: 20, marginTop: 10 }}>{formError}</div>}

          <ActionWrapper>
            <FormInputWrapper
              style={{
                minWidth: '40%',
                marginTop: '40px',
                display: 'flex',
                alignItems: 'center',
                marginRight: '-250px',
              }}
            >
              {/* <CustomCheckBox
                label="defaultAccount"
                id="isDefault"
                name="isDefault"
                checked={formik.values.isDefault}
                onChange={() => formik.setFieldValue('isDefault', !formik.values.isDefault)}
              /> */}
            </FormInputWrapper>

            <FormInputWrapper
              style={{
                display: 'flex',
                alignItems: 'center',
                marginLeft: '10px',
                marginTop: '35px',
                marginRight: '-20px',
              }}
            >
              {/* Ensure button has type="submit" */}
              {/* <RegularButton type="submit">
                {isLoading ? (
                  <span style={{ display: 'flex', alignItems: 'center' }}>
                    <CircularProgress size={20} style={{ marginRight: 8 }} />
                    Saving...
                  </span>
                ) : (
                  'Save'
                )}
              </RegularButton> */}
              <RegularButton
                type="button"
                onClick={() => formik.handleSubmit()}
                style={{ marginLeft: '174px' }}
                // disabled={!formik.isValid || addAddAddress.isLoading}
              >
                {t('global.form.saveSubmit')}
              </RegularButton>
            </FormInputWrapper>
          </ActionWrapper>
        </DependentsForm>
      </DependentsForms>
    </ReactModal>
  );
};
